import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/accion-logo.png'
import footerBackground from '../img/addon-footer.png'

export default function Footer() {
    return (
        <footer className='flex-row align-center justify-center'>
            <img className='footer-background' src={footerBackground}></img>
            <div className='flex-column align-center justify-center'>
                <img src={logo} />
                <p><a href='#'>Colaboradores</a> | <a href='#'>Política de privacidad</a></p>
            </div>
        </footer>
    )
}